<template>
    <Paper :header="$t('spotlight.personalDetails.header')" tall>
        <PersonalDetailsSkeleton v-if="isLoading" />
        <div v-else class="p-4 content">
            <div class="form">
                <TextField
                    :label="
                        $t('spotlight.personalDetails.firstName').concat(':')
                    "
                    :placeholder="$t('spotlight.personalDetails.firstName')"
                    v-model="value.firstName"
                    maxlength="100"
                    margin
                />

                <TextField
                    :label="
                        $t('spotlight.personalDetails.lastName').concat(':')
                    "
                    :placeholder="$t('spotlight.personalDetails.lastName')"
                    v-model="value.lastName"
                    maxlength="100"
                    margin
                />

                <h6 class="subtitle bold">
                    {{ $t('spotlight.personalDetails.nationality') }}:
                </h6>
                <BaseSearchable
                    :placeholder="$t('spotlight.personalDetails.nationality')"
                    class="mb-4"
                    autocomplete="country-name"
                    :data="nationalities"
                    :value="nationality"
                    @input="onNationalityChange"
                />
            </div>
            <div
                class="mx-2 profile-image d-flex flex-column justify-content-between"
            >
                <input
                    v-show="false"
                    type="file"
                    ref="fileInput"
                    @change="
                        onFileChange($event.target.name, $event.target.files)
                    "
                />

                <div
                    v-if="imgUrl || value.image"
                    class="d-flex"
                    style="z-index: 100; height: 0; margin-bottom: -28.5px; overflow: show;"
                >
                    <div class="flex-grow" />
                    <IconBtn
                        class="primary-outlined closeBtnWrapper align-self-start clickable"
                        name="times"
                        size="lg"
                        @click="handleRemoveImage"
                    />
                </div>

                <div style="position: relative;">
                    <b-img
                        v-if="imgUrl || value.image"
                        class="profile-img"
                        :src="imgUrl || value.image + '/medium.jpg'"
                        rounded="circle"
                    />
                    <div v-else>
                        <Avatar class="profile-img" size="huge">
                            {{ firstLetterOfName() }}
                        </Avatar>
                    </div>
                    <div
                        style="position: absolute; bottom: 0; right: 0; left: 0;"
                    >
                        <UniConnections />
                    </div>
                </div>

                <BaseButton
                    class="mb-4 upload-img-btn"
                    variant="outline-secondary"
                    @click="() => $refs['fileInput'].click()"
                    >{{
                        $t('spotlight.personalDetails.uploadProfileImage')
                    }}</BaseButton
                >
            </div>
        </div>
    </Paper>
</template>

<script>
// Utils
import StateEnum from '~/utils/StateEnum';

// Data imports
import countries from '~/data/countries.json';
import MessageState from '~/store/customModules/messageModule';

// Component specific components
import UniConnections from './UniConnections';
import PersonalDetailsSkeleton from '../skeletons/PersonalDetailsSkeleton';

export default {
    name: 'PersonalDetails',
    components: { UniConnections, PersonalDetailsSkeleton },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        oldVal: {
            type: Object,
            default: () => ({}),
        },
        isLoading: Boolean,
    },
    data: () => ({
        nationalities: countries,
        StateEnum: StateEnum,
        imgUrl: null,
    }),
    computed: {
        nationality() {
            return {
                value: this.value.nationality,
                label: this.value.nationality,
            };
        },
        user() {
            return this.$interfaces.user.me.get({ reactive: true }) || {};
        },
    },
    methods: {
        resetChangedImage() {
            this.imgUrl = null;
        },
        handleRemoveImage() {
            console.log(this.imgUrl, this.value.image);
            if (this.imgUrl && this.imgUrl !== this.value.image) {
                this.imgUrl = null;
                this.$emit('image:removed');
            } else {
                this.$emit('removeOldImage');
            }
        },
        alert(str) {
            alert(str);
        },
        onFileChange(fileName, files) {
            if (files.length > 0) {
                let imageFile = files[0];
                let size = imageFile.size;
                if (!imageFile.type.match('image.*')) {
                    this.$interfaces.messageModule.addNewMessage({
                        title: this.$t(
                            'spotlight.personalDetails.wrongFileTypeErrorHeader'
                        ),
                        message: this.$t(
                            'spotlight.personalDetails.wrongFileTypeErrorDescription'
                        ),
                        state: MessageState.NOTIFICATION,
                        duration: 6000,
                    });
                } else {
                    this.imgUrl = URL.createObjectURL(imageFile);
                    this.$emit('image:changed', imageFile);
                }
            }
        },
        onNationalityChange(newVal) {
            this.$emit('input', {
                ...this.value,
                nationality: newVal ? newVal.value : null,
            });
        },
        firstLetterOfName() {
            const userData = this.user.data;
            return userData && userData.firstName ? userData.firstName[0] : 'A';
        },
    },
};
</script>

<style scoped>
.content {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-template-areas: 'form profile-image';
}
.form {
    grid-area: form;
}
.profile-image {
    grid-area: profile-image;
    padding-left: 12px;
}
.profile-img {
    width: 140px !important;
    height: 140px !important;
    margin: 16px auto;
    display: block;
    max-width: 200px;
    max-height: 200px;
    object-fit: cover;
    font-size: 22px;
}

@media only screen and (max-width: 800px) {
    .profile-img {
        width: 50%;
    }
}
@media only screen and (max-width: 600px) {
    .content {
        grid-template-columns: 1fr;
        grid-template-areas: 'form' 'profile-image';
    }
    .profile-image {
        padding-left: 0;
        margin-top: 16px;
    }
    .upload-img-btn {
        margin-top: 16px;
    }
}
</style>
